module.exports = __webpack_public_path__ + "static/project-industrial_nowhurst.f38b2ebf.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/terrymasher/Development/glenbeigh-ltd/src/static/img/project-industrial_nowhurst.jpg
// module id = 289
// module chunks = 0 1